import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import useTooltip from '../../CmdTable/hooks/useTooltip';
import CustomTooltip from '../../CmdTable/CustomTooltip';
import { driverSelector } from '../TripsOverviewState';

interface IDriverProps {
  id: string;
  datacyIndex: number;
}

function DriverCell(props: IDriverProps) {
  const { formatMessage: f } = useIntl();
  const driver = useRecoilValue(driverSelector(props.id));
  const [showTooltip, setShowTooltip] = React.useState<boolean>(false);
  const refSize = React.useRef<HTMLDivElement>(null);
  const { hover, tooltipPos, textRef, handleMouseEnter, handleMouseLeave } = useTooltip();

  React.useEffect(() => {
    const isTextTruncated = () => {
      if (!textRef.current) return false;
      return textRef.current.offsetWidth < textRef.current.scrollWidth;
    };

    setShowTooltip(isTextTruncated());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [driver]);

  return (
    <div
      ref={refSize}
      id="element-width-driver"
      className="align-middle"
      style={{ minWidth: '120px', flex: 1 }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <CustomTooltip
        content={driver?.name || f({ id: 'enum.ridebooks.unassignedDriver' })}
        show={hover && showTooltip}
        position={tooltipPos}
        truncateClassName="text-truncate"
      >
        <div
          data-cy={`row-${props.datacyIndex + 1}-driver`}
          className="text-truncate"
          ref={textRef}
          style={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
        >
          {driver?.name || f({ id: 'enum.ridebooks.unassignedDriver' })}
        </div>
      </CustomTooltip>
    </div>
  );
}

export default React.memo(DriverCell);
